import { render, staticRenderFns } from "./default.vue?vue&type=template&id=3fb71f0d"
import script from "./default.vue?vue&type=script&lang=js"
export * from "./default.vue?vue&type=script&lang=js"
import style0 from "./default.vue?vue&type=style&index=0&id=3fb71f0d&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NavBar: require('C:/4Team_Git/FT.Web.Products/FT.Web.Templated/components/NavBar.vue').default,SvgRender: require('C:/4Team_Git/FT.Web.Products/FT.Web.Templated/components/SvgRender.vue').default,Layout: require('C:/4Team_Git/FT.Web.Products/FT.Web.Templated/components/Layout.vue').default,Dialog: require('C:/4Team_Git/FT.Web.Products/FT.Web.Templated/components/Dialog.vue').default,DiscountBanner: require('C:/4Team_Git/FT.Web.Products/FT.Web.Templated/components/DiscountBanner.vue').default,DiscountText: require('C:/4Team_Git/FT.Web.Products/FT.Web.Templated/components/DiscountText.vue').default,Stepper: require('C:/4Team_Git/FT.Web.Products/FT.Web.Templated/components/Stepper.vue').default,Link: require('C:/4Team_Git/FT.Web.Products/FT.Web.Templated/components/Link.vue').default,PaymentSection: require('C:/4Team_Git/FT.Web.Products/FT.Web.Templated/components/PaymentSection.vue').default,Footer: require('C:/4Team_Git/FT.Web.Products/FT.Web.Templated/components/Footer.vue').default})
